const uploadPreparedAssessmentColumnHeaders = {
  YEAR: 'Year',
  MARKET_GROUP: 'MG (C2) Description (Reference)',
  BUSINESS_UNIT: 'BU (C3) Description (Reference)',
  C6_ID: 'C6 ID',
  C6_DESCRIPTION: 'C6 Description (Reference)',
  CUSTOMER_ID: 'Customer ID',
  CUSTOMER_DESCRIPTION: 'Customer Description (Reference)',
  CHANNEL: 'Channel',
  OMNI: 'Omni',
};

const uploadPreparedAssessmentColumnHeaderAccessors = {
  [uploadPreparedAssessmentColumnHeaders.YEAR]: 'year',
  [uploadPreparedAssessmentColumnHeaders.MARKET_GROUP]: 'marketGroup',
  [uploadPreparedAssessmentColumnHeaders.BUSINESS_UNIT]: 'businessUnit',
  [uploadPreparedAssessmentColumnHeaders.C6_ID]: 'c6Id',
  [uploadPreparedAssessmentColumnHeaders.C6_DESCRIPTION]: 'c6Name',
  [uploadPreparedAssessmentColumnHeaders.CUSTOMER_ID]: 'customerId',
  [uploadPreparedAssessmentColumnHeaders.CUSTOMER_DESCRIPTION]: 'customerName',
  [uploadPreparedAssessmentColumnHeaders.CHANNEL]: 'channel',
  [uploadPreparedAssessmentColumnHeaders.OMNI]: 'omni',
};

export {
  uploadPreparedAssessmentColumnHeaders,
  uploadPreparedAssessmentColumnHeaderAccessors,
};
